import { render, staticRenderFns } from "./corporate-actions.vue?vue&type=template&id=e576a49e&scoped=true"
import script from "./corporate-actions.vue?vue&type=script&lang=js"
export * from "./corporate-actions.vue?vue&type=script&lang=js"
import style0 from "./corporate-actions.vue?vue&type=style&index=0&id=e576a49e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e576a49e",
  null
  
)

/* custom blocks */
import block0 from "./corporate-actions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,SearchInput: require('/vercel/path0/components/SearchInput.vue').default,InfoBox: require('/vercel/path0/components/InfoBox.vue').default,LoadingAnimation: require('/vercel/path0/components/ui/LoadingAnimation.vue').default})
